
import Mask from "../../../assets/outline/Mask.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MaskIcon({ className, dataTestid = "MaskIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Mask data-testid={dataTestid} className={classes} {...rest} />
  );
}
